import React from 'react';

export default () => (
  <>
    <section className="container icons-section">
      <div className="row">
        <div className="col-xl-12">
          <ul className="b-welcome-list list-unstyled d-sm-flex justify-content-around">
            <li className="b-welcome-list__item flex-fill">
              <img src="../fonts/flaticon/svg/car.svg" alt="" />
              {startup.content.WelcomeIcon1}
              <br />
              {startup.content.WelcomeIcon1_1}
            </li>
            <li className="b-welcome-list__item flex-fill">
              <img src="../fonts/flaticon/svg/loan.svg" alt="" />
              {startup.content.WelcomeIcon2}
              <br />
              {startup.content.WelcomeIcon2_1}
            </li>
            <li className="b-welcome-list__item flex-fill">
              <img src="../fonts/flaticon/svg/money.svg" alt="" />
              {startup.content.WelcomeIcon3}
              <br />
              {startup.content.WelcomeIcon3_1}
            </li>
            <li className="b-welcome-list__item flex-fill">
              <img src="../fonts/flaticon/svg/service .svg" alt="" />
              {startup.content.WelcomeIcon4}
              <br />
              {startup.content.WelcomeIcon4_1}
            </li>
          </ul>
        </div>
      </div>
    </section>
  </>
);
